export { FLAGS, flagsConfig } from '@fs/zion-rootstech'

/**
 * Additional feature flags not yet available in @fs/zion-rootstech
 */

// Schedule calendar flag - controls which BSP calendars to fetch
// 'on' = multi-stage calendar only
// 'off' or null = main-stage + sessions (default)
export const NEW_CALENDAR_FLAG = 'rootstech_new_calendar'
